var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgBell = function SvgBell(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 2.25C8.19416 2.25 4.98379 5.08406 4.51172 8.86064L3.5228 16.772C3.32514 18.3533 4.55813 19.75 6.15174 19.75H7.5127L7.56505 19.8678C8.34402 21.6205 10.0821 22.75 12.0001 22.75C13.9181 22.75 15.6562 21.6205 16.4352 19.8678L16.4875 19.75H17.8485C19.4421 19.75 20.6751 18.3533 20.4775 16.772L19.4886 8.86064C19.0165 5.08406 15.8061 2.25 12.0001 2.25ZM16.0172 18.25C16.0061 18.2498 15.9949 18.2498 15.9838 18.25H8.0164C8.00528 18.2498 7.99415 18.2498 7.98299 18.25H6.15174C5.46038 18.25 4.92547 17.6441 5.01122 16.958L6.00014 9.04669C6.37838 6.02075 8.95065 3.75 12.0001 3.75C15.0496 3.75 17.6219 6.02075 18.0001 9.04669L18.9891 16.958C19.0748 17.6441 18.5399 18.25 17.8485 18.25H16.0172ZM9.20531 19.75H14.7949C14.1807 20.6765 13.1361 21.25 12.0001 21.25C10.8641 21.25 9.8195 20.6765 9.20531 19.75Z",
    fill: "#22282F"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgBell);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Bell.762db183ab4af22ef4dbf6251c7e3b96.svg";